import React, { useState } from "react";
import { Chart } from "primereact/chart";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

const getMonthName = (periodo) => {
  const parts = periodo.split("-");
  const month = parts[1];
  const months = {
    "01": "Enero",
    "02": "Febrero",
    "03": "Marzo",
    "04": "Abril",
    "05": "Mayo",
    "06": "Junio",
    "07": "Julio",
    "08": "Agosto",
    "09": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
  };
  return `${months[month]} ${parts[0]}` || periodo;
};

const DashboardAnalytics = ({ data }) => {
  const [showTable, setShowTable] = useState(false);

  const chartData = {
    labels: data.map((item) => getMonthName(item.mes)),
    datasets: [
      {
        label: "Arriendo",
        data: data.map((item) => item.categoria_total.arriendo || 0),
        backgroundColor: "#42A5F5",
        borderColor: "#42A5F5",
        borderWidth: 2,
      },
      {
        label: "Gasto Común",
        data: data.map((item) => item.categoria_total.gastoComun),
        backgroundColor: "#66BB6A",
        borderColor: "#66BB6A",
        borderWidth: 2,
      },
      {
        label: "Servicios",
        data: data.map((item) => item.categoria_total.servicio),
        backgroundColor: "#FFA726",
        borderColor: "#FFA726",
        borderWidth: 2,
      },
      {
        label: "Obras Civiles",
        data: data.map((item) => item.categoria_total.obra),
        backgroundColor: "#AB47BC",
        borderColor: "#AB47BC",
        borderWidth: 2,
      },
    ],
  };
  const chartOptions = {
    maintainAspectRatio: false,
    scales: {
      y: { beginAtZero: true },
      x: { categoryPercentage: 0.9, barPercentage: 0.8 },
    },
  };

  return (
    <div className="grid dashboard">
      <div className="col-12">
        <div className="card">
          <h5>Total por Categorías</h5>
          
          <Chart
            type="bar"
            data={chartData}
            options={chartOptions}
            height="400px"
          />
          <div className="mt-3" style={{ display: "flex", justifyContent: "center" }}>
            <button
              icon="pi pi-exchange"
              className="p-button-secondary p-button-raised p-button p-button-rounded"
              onClick={() => setShowTable(!showTable)}
            >
              {showTable ? "Ocultar Detalle" : "Mostrar Detalle"}
            </button>
          </div>
          {showTable && (
            
            <DataTable value={data} 
            stripedRows
            showGridlines
            className="mt-3">
        
              <Column
                header="Mes"
                body={(rowData) => getMonthName(rowData.mes)}
              />
              <Column
                field="arriendo"
                header="Arriendo"
                body={(rowData) => `UF ${(rowData.categoria_total.arriendo || 0).toFixed(2)}`}
              />
              <Column
                field="gastoComun"
                header="Gasto Común"
                body={(rowData) => `UF ${(rowData.categoria_total.gastoComun || 0).toFixed(2)}`}
              />
              <Column
                field="servicio"
                header="Servicios"
                body={(rowData) => `UF ${(rowData.categoria_total.servicio || 0).toFixed(2)}`}
              />
              <Column
                field="obra"
                header="Obras Civiles"
                body={(rowData) => `UF ${(rowData.categoria_total.obra || 0).toFixed(2)}`}
              />
              <Column
                header="Total"
                body={(rowData) => `UF ${(rowData.totalRdUfFinal || 0).toFixed(3)}`}
              />
            </DataTable>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(DashboardAnalytics);
